import { Paper, Stack, Text, Divider, SimpleGrid, Center, Collapse } from "@mantine/core";
import type { OEJTresult } from "@/q-n-a";
import { NumberLine,  } from "@/componets/NumberLine";
import { NumberLinePropPresets } from "@/presets.datashaps";
import MarkViewer from '@/componets/mark.viewer';
import TestLink from "@/componets/testlink";
import { useToggle } from "@mantine/hooks";
import { SocialSharePanel } from "@/componets/social.shares";

export interface ResultsPanelProps {
    results: OEJTresult;
    strType: string;
    imgUrl: string;
    resultUrl?: string;
    testeeName?: string;
}

export default function ResultsPanel({ results, strType, imgUrl, resultUrl, testeeName }: ResultsPanelProps) {
    const [showFull, toggleFull] = useToggle();
    const mdFetch = async (id: string) => {
        const res = await fetch(`/api/library/${id}`);
        return await res.text();
    }


    return (
        <Paper p={'sm'} withBorder shadow="md" radius={12}>
            {!!resultUrl && <TestLink testUrl={resultUrl} linkText="Bookmark results" mb={10} />}
            {!!resultUrl && <SocialSharePanel imageDataUrl={imgUrl} caption="Share your results" shareUrl={resultUrl} />}
            <Text fw={300} size="1.5rem">{!!testeeName ? `${testeeName}'s` : 'Your'} Results</Text>
            <SimpleGrid cols={{ base: 1, md: 2 }}>
                <Stack gap={'md'} justify="start" px={24}>
                    <Text>
                        <Text span c={'dimmed'}>Personality Type: </Text>
                        <Text span fw={300} size="1.3rem" ml={10}>{strType}</Text>
                    </Text>
                    <Divider color='dimmed' />
                    {Object.entries(results).map(([key, value], index) => (
                        <NumberLine key={`${key}-${index}`} {...NumberLinePropPresets[key as keyof typeof NumberLinePropPresets]} value={value} />
                    ))}
                    <Divider color='dimmed' />
                </Stack>
                <Stack gap={'md'} justify="center">
                    <MarkViewer id={`personal_breakdown/${strType}_1b_personality_overview.md`} markdownFetchFn={mdFetch} />
                    <Paper p={'sm'} withBorder shadow="md" radius={4}>
                        <Center>
                            <Text 
                                onClick={() => toggleFull()}
                                p={4}
                                px={24}
                                styles={{root: {cursor: 'pointer'}}}
                                bd={'1.5px solid var(--mantine-color-default-border)'}
                                bdrs={12}
                            >
                                {showFull ? 'Hide' : 'Show'} Full Report
                            </Text>
                        </Center>
                        <Collapse in={showFull}>
                            <MarkViewer id={`personal_breakdown/${strType}_2a_personality_analysis.md`} markdownFetchFn={mdFetch} />
                        </Collapse>
                    </Paper>
                </Stack>

            </SimpleGrid>

        </Paper>
    )
}